var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VSelect',{staticStyle:{"max-width":"425px"},attrs:{"options":_vm.tabsList,"value":_vm.getSelectValue,"item-text":_vm.itemText,"allow-empty":false,"not-search":"","name":"navItem"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }